export const defaultThemes = Object.freeze({
    WHITE_MODE_DEFAULT: "WHITE_MODE_DEFAULT",
    DARK_MODE_DEFAULT: "DARK_MODE_DEFAULT",
});
